import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {GlobalApplicationState} from '../reducers/RootReducer';

export const selectHighlightedProducts = ({
    highlightedProductsState,
}: GlobalApplicationState): ProductInCatalog[] => highlightedProductsState.highlightedProducts;
